import { computed, type ComputedRef } from 'vue'
import { generateDataLhId } from '@/utils/data-lh-id'
import type { DataLhIdModule } from '@/utils/data-lh-id/types'

export const useDataLhId = (params: DataLhIdModule.DataLhIdParams): ComputedRef<string> => {
  return computed(() => generateDataLhId(params))
}
